import { initializeEcho } from '@night-owl-elite/vue3-ws';
import { useAuthStore } from '@/stores/useAuthStore';


export function setupWebSockets() {
  const authStore = useAuthStore();

  initializeEcho({
    key: import.meta.env.VITE_PUSHER_APP_KEY || '',

     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || 'mt1',

    // Reverb / Soketi optional
    host: import.meta.env.VITE_PUSHER_HOST,
    port: import.meta.env.VITE_PUSHER_PORT,
    scheme: import.meta.env.VITE_PUSHER_SCHEME,

    authEndpoint: import.meta.env.VITE_WEBSOCKET_ENDPOINT || '/api/broadcasting/auth',

     token: () => authStore?.getUserToken || ''
  });
}

